import { useGetContext } from '../api/lendingApi/lendingApiQueries';

export function useContextStateKey(): string | undefined {
  const { context } = useGetContext();

  return context?.state_key;
}
